const getEpoch = () => (Date.now() / 1000);

let configJsonPath = (`/${location.pathname}///app-config.json?timestamp=${getEpoch()}`);
while (/\/\//.test(configJsonPath)) {
  configJsonPath = configJsonPath.replace('//', '/');
}
const configJsonUri = `${location.origin}${configJsonPath}`;

let configPromise: Promise<AppConfig>;

const configRequest = () => configPromise || (configPromise = fetch(configJsonUri).then(response => response.json()));

export const ConfigurationService = {
  getConfiguration(): Promise<AppConfig> {
    return configRequest();
  }
};
